var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Close = function (_a) {
    var className = _a.className;
    return (_jsxs("svg", __assign({ width: "14", height: "14", className: className, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M13 1L1 13", stroke: "red", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M1 1L13 13", stroke: "red", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] })));
};
export default Close;
//# sourceMappingURL=close.js.map